import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Undo2, Download } from "lucide-react";
import { call, download } from "./common";

const TYPES = [["", "All"], ["redirect_create", "Redirect created"], ["redirect_update", "Redirect changed"], ["redirect_delete", "Redirect deleted"],
  ["link_fix", "Internal link repaired"], ["slug_change", "Product URL changed"], ["batch", "Batch approvals"], ["scan", "Scans"], ["import", "Imports"], ["restore", "Restores"]];
const RESTORABLE = new Set(["redirect_create", "redirect_update", "redirect_delete", "link_fix", "batch", "issue_reject", "issue_gone", "issue_ignore"]);

export default function AuditLog({ tick, onChange }) {
  const [type, setType] = useState("");
  const [skip, setSkip] = useState(0);
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/url-repair/audit", { params: { type, skip, limit: 50 } }).then((r) => setData(r.data)); }, [type, skip, tick]);
  const restore = (a) => window.confirm(`Restore: ${a.summary}?`) && call(() => api.post(`/admin/url-repair/audit/${a.id}/restore`), "Restored").then((x) => x && onChange());
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2 items-center">
        <select value={type} onChange={(e) => { setType(e.target.value); setSkip(0); }} className="h-9 rounded-md border px-2 text-sm bg-white" data-testid="ur-audit-type">
          {TYPES.map(([v, l]) => <option key={l} value={v}>{l}</option>)}</select>
        <Button variant="ghost" onClick={() => download("/admin/url-repair/export/audit.csv", "url-repair-audit.csv")} data-testid="ur-export-audit"><Download size={15} className="mr-1" />Audit report CSV</Button>
      </div>
      <div className="rounded-xl border bg-white divide-y">
        {!data ? <p className="p-3 text-sm text-muted-foreground">Loading…</p> : data.items.length === 0 ? <p className="p-3 text-sm text-muted-foreground">No activity yet.</p>
          : data.items.map((a) => (
            <div key={a.id} className="flex flex-wrap items-center gap-2 p-3 text-sm" data-testid={`ur-audit-${a.id}`}>
              <div className="min-w-0 flex-1"><div className="break-all">{a.summary}</div>
                <div className="text-[11px] text-muted-foreground">{a.at_nz} · {a.type.replace("_", " ")} · {a.actor}</div></div>
              {a.restored ? <span className="text-xs text-muted-foreground">Restored</span>
                : RESTORABLE.has(a.type) && <Button size="sm" variant="outline" className="h-7" onClick={() => restore(a)} data-testid={`ur-restore-${a.id}`}><Undo2 size={13} className="mr-1" />Restore</Button>}
            </div>))}
      </div>
      {data && data.total > 50 && <div className="flex gap-2">
        <Button size="sm" variant="outline" disabled={skip === 0} onClick={() => setSkip(Math.max(0, skip - 50))}>Previous</Button>
        <Button size="sm" variant="outline" disabled={skip + 50 >= data.total} onClick={() => setSkip(skip + 50)}>Next</Button></div>}
    </div>
  );
}
